<template>
  <div class="top-wrapper">
    <router-view />
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from "vue"
import { useRoute, useRouter } from "vue-router"
import { useStore } from "vuex"
import { checkLoginStatusAndProcess, getUserFromStorageIfNeed, getGameRuleList, getScoreLimit } from '@/api.js'

const {
  windowSizeInCssForRef,
  windowSizeWhenDesignForRef,
} = useSizeAdapt(390, 752)

const route = useRoute()
const router = useRouter()
const store = useStore()

// checkLoginStatusAndProcess()
getUserFromStorageIfNeed()

getGameRuleList().then((res) => {
  store.commit('setGameRuleList', res)
})
getScoreLimit().then((res) => {
  store.commit('setScoreLimit', res.score)
  const resetInfo = JSON.parse(res.description)
  if (resetInfo.hasReset) {
    const currentTimeMs = new Date().getTime()
    const createTime = new Date(resetInfo.createTime)
    const period = resetInfo.period
    let resetTimeMs = createTime.getTime() + period * 24 * 60 * 60 * 1000
    while (resetTimeMs <= currentTimeMs) {
      resetTimeMs = resetTimeMs + period * 24 * 60 * 60 * 1000
    }
    store.commit('setScoreResetDateMs', resetTimeMs)
  } else {
    store.commit('setScoreResetDateMs', null)
  }
})

</script>

<style lang="less">
html, body {
  overscroll-behavior: none;
  overflow: hidden;
  height: 100%;
}

// * {
//   user-select: none;
//   -webkit-touch-callout: none;
// }

#app {
  height: 100%;
  position: relative;
  left: 50%;
  top: 0;
  transform: translate(-50%, 0);
}

// // 360浏览器不支持not()
// input, textarea {
//   user-select: initial;
// }

// 字体
// @font-face {
//   font-family: 'Source Han Serif CN';
//   src: url('@/assets/style/SourceHanSerifCN-Regular.otf');
// }
@font-face {
  font-family: 'heiti';
  src: url('@/assets/style/Adobe Heiti Std.otf');
}
// i {
//   font-style: italic;
// }

// 滚动条，只设置某一项可能导致不生效。
.not-mobile{
  ::-webkit-scrollbar { background: #dddecc; width: 6px; height: 6px; }
  ::-webkit-scrollbar-thumb { background: #828a5b; border-radius: 3px; }
  ::-webkit-scrollbar-corner { background: #dddecc; }
}

// vue组件过渡效果
.fade-out-leave-active {
  transition: opacity 1s;
  pointer-events: none;
}
.fade-out-leave-to {
  opacity: 0;
}

// vue组件过渡效果
.fade-in-enter-active {
  transition: opacity 1s;
}
.fade-in-enter-from {
  opacity: 0;
}

.fade-out-leave-active {
  transition: opacity 1s;
  pointer-events: none;
}
.fade-out-leave-to {
  opacity: 0;
}

.fade-in-out-enter-active {
  transition: opacity 1s;
}
.fade-in-out-leave-active {
  transition: opacity 1s;
  pointer-events: none;
}
.fade-in-out-enter-from {
  opacity: 0;
}
.fade-in-out-leave-to {
  opacity: 0;
}

// 不断渐变显隐 animation
.animation-show-hide {
  animation: show-hide 1.8s infinite;
}
@keyframes show-hide {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

// // vue-viewer
// .viewer-container {
//   background-color: rgba(0, 0, 0, 80%) !important;
// }
// 或者
// .viewer-backdrop {
//   background-color: rgba(0, 0, 0, 90%) !important;
// }
</style>

<style lang="less" scoped>
.top-wrapper{
  position: absolute;
  left: 50%;
  top: 0;
  transform: translate(-50%, 0);
  width: calc(390 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
  height: 100%;
}
</style>